import { Svg, G, Path, Defs, ClipPath, Rect } from '../_Svg';
import type { IconComponent } from '..';
import useIconProps from '../useIconProps';
import { assignWithoutSideEffects } from '~utils/assignWithoutSideEffects';

const _PinIcon: IconComponent = ({ size, color, ...styledProps }) => {
  const { height, width, iconColor } = useIconProps({ size, color });

  return (
    <Svg {...styledProps} width={width} height={height} viewBox="0 0 24 24" fill="none">
      <G clipPath="url(#clip0_84476_40850)">
        <Path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M20.4057 4.08833L20.4086 4.09121L20.4115 4.09408L23.255 6.93898C23.5829 7.26713 23.7671 7.71207 23.7671 8.17601C23.7671 8.63976 23.5826 9.08492 23.255 9.41304L18.3527 14.3307C19.1644 16.7901 17.7647 19.0587 17.0272 20.0396L17.0234 20.0446C16.8725 20.2428 16.681 20.4064 16.4618 20.5246C16.2425 20.6428 16.0005 20.7128 15.7521 20.73C15.5036 20.7472 15.2543 20.7112 15.0208 20.6243C14.7874 20.5374 14.5752 20.4017 14.3984 20.2262L14.3959 20.2236L10.0427 15.8708L6.00514 19.9083C5.61461 20.2989 4.98145 20.2989 4.59092 19.9083C4.2004 19.5178 4.2004 18.8846 4.59092 18.4941L8.62844 14.4566L4.27617 10.1039L4.27361 10.1014C4.09813 9.92459 3.96241 9.71239 3.87552 9.47895C3.78863 9.24551 3.75257 8.99622 3.76976 8.74773C3.78695 8.49925 3.85698 8.25729 3.97518 8.03804C4.09338 7.81878 4.25702 7.62728 4.45516 7.47634L4.46021 7.47255C5.44111 6.73511 7.70967 5.33539 10.1691 6.1471L15.0871 1.24445C15.4153 0.916751 15.86 0.732675 16.3238 0.732675C16.7877 0.732675 17.2327 0.916954 17.5609 1.24489L20.4057 4.08833ZM10.7522 13.752L10.75 13.7498L10.7478 13.7476L5.89997 8.89932C6.93372 8.18261 8.49317 7.48591 9.9575 8.2184C10.342 8.41073 10.8064 8.33578 11.1109 8.03226L16.3235 2.83591L18.9918 5.50289L18.9944 5.50541L18.9969 5.50794L21.6639 8.17624L16.4675 13.3889C16.164 13.6934 16.0891 14.1578 16.2814 14.5423C17.0139 16.0066 16.3172 17.5661 15.6005 18.5998L10.7522 13.752Z"
          fill={iconColor}
        />
      </G>
      <Defs>
        <ClipPath id="clip0_84476_40850">
          <Rect width="24" height="24" fill={iconColor} transform="translate(0.5)" />
        </ClipPath>
      </Defs>
    </Svg>
  );
};

const PinIcon = assignWithoutSideEffects(_PinIcon, {
  componentId: 'PinIcon',
});

export default PinIcon;
